import styled from 'styled-components'

export const StyledDepositBtn = styled.button`
  position: absolute;
  right: 15px;
  top: 55px;
  background: #5f4dbc;
  border-radius: 34px;
  color: #fff;
  padding: 6px 15px;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  outline: none;
  border: none;
`

export const StyledPersonalAssetContainer = styled.section`
  margin-top: 45px;
  .asset-title {
    color: #9598ab;
    font-weight: 500;
    font-size: 17px;
    margin-left: 10px;
    .eye-on {
      padding-left: 8px;
    }
    .discount-tips {
      color: #9598ab;
      font-size: 15px;
      padding-left: 10px;
    }
  }
  @media screen and (max-width: 640px) {
    .asset-data-container {
      display: flex;
      flex-direction: column;
      .data-container {
        width: 100%;
      }
      .middle-container {
        margin: 15px 0px !important;
      }
      .last-container {
        margin-left: 0;
        margin-top: 15px;
      }
    }
    .fullpage-content-container {
      padding: 45px 20px 40px !important;
    }
  }
`

export const StyledAssetDataContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  .data-container {
    position: relative;
    width: 380px;
    .content {
      margin-top: 7px;
      margin-bottom: -7px;
    }
    &__Lon {
      .content {
        color: #5f4dbc;
      }
    }

    &__xLon {
      .content {
        color: #bd89f0;
      }
    }
  }

  .middle-container {
    position: relative;
    margin: 0 30px;
  }
  .last-container {
    position: relative;
    margin-left: 31px;
    .title-container {
      .sub-title {
        font-size: 13px;
        color: #9598ab;
        .time {
          margin-left: 6px;
        }
      }
    }
  }
  .common-modal-container {
    position: absolute;
    top: 0;
    z-index: 99;
    @media screen and (max-width: 640px) {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 101;
      width: 100%;
      .common-state-modal {
        width: 100% !important;
        border-radius: 16px 16px 0 0 !important;
      }
    }
  }
`

export const StyledConnectWalletContainer = styled.div`
  padding: 32px 0;
  background: #fafbfc;
  border-radius: 12px;
  width: 100%;
  text-align: center;
  .link {
    color: #5f4dbc;
    font-weight: 500;
    font-size: 15px;
  }
`
